/**
 * URL-bound index filter (`idx`).
 */
import { DEFAULT_FILTER, FilterKeySchema, type FilterKey } from '@meridian/contracts';

import { useSearchEnumParam } from './use-search-enum-param';

export function useIndexParam(): {
  readonly index: FilterKey;
  readonly setIndex: (idx: FilterKey) => void;
} {
  const { value, setValue } = useSearchEnumParam('idx', FilterKeySchema, DEFAULT_FILTER);
  return { index: value, setIndex: setValue };
}
